import React, { useState } from 'react';
import { FaDesktop, FaMobileAlt } from 'react-icons/fa';
import { FaWarehouse } from 'react-icons/fa6';

const StockStatus = () => {
    const [activeTab2, setActiveTab2] = useState('web');
    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];
    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => !tab.disabled && setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? 'bg-[#1a9588] text-white shadow-md'
                        : 'bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600'
                        } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={tab.disabled}
                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );

    return (
        <div>
            <div className="flex items-center gap-4 mb-8">
                <FaWarehouse className="text-pink-600 text-5xl" />
                <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900">Stock Status</h1>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
                <div className="flex flex-wrap gap-2">
                    <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Seller
                    </span>
                    <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Buyer
                    </span>
                </div>
                <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Web
                    </span>
                
                    <span className="bg-green-100 text-green-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Android
                    </span>
                </div>
            </div>
            <p className="text-start mb-6 text-gray-600 text-gray-300">
              Selzor does not connect directly with your 'Inventory', but it allows you to communicate the stock status of each product and size to your buyers. Predefined statuses like In Stock, Out of Stock, Low Stock, Low Supply, and Backorder are provided, and you can rename them to suit your needs.
            </p>
            {/* <div className="text-start">
                <h3 className="text-2xl text-gray-500 mb-2">Adding / Updating Products</h3>
                <p className="text-gray-600 mb-6">
                    Go to the 'Products' section & click on 'Add New'. Fill in the fields and click 'Save'. The new product is saved to the database.
                </p>
            </div> */}
         
            <div>
                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Add / Update Stock Status</h3>
                    <p className="text-gray-600 mb-6">
                      Stock Status can be managed in the 'Settings' section. To create a new stock status, click 'Add New' and enter the label for the status.
                    </p>
                </div>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className="bg-red-100 text-red-800 p-4 rounded-lg border border-red-300 text-start">
              Stock Status once defined cannot be deleted.
            </div>

            <div className='my-5'>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src=""
                        alt={`${activeTab2} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>

                <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start">
                    Use the toggle to show or hide a stock status for all products. The changes will only take effect once you publish your product data.
                </div>
            </div>

            
        </div>
    );
};

export default StockStatus;